<template functional>
  <a-sub-menu :key="props.route.path">
    <span slot="title"
      ><a-icon
        v-if="props.route.meta.icon"
        :type="props.route.meta.icon"
      /><span>{{ props.route.meta.title }}</span></span
    >
    <template v-for="child of props.route.children">
      <template v-if="!child.children">
        <a-menu-item :key="child.path" v-if="!child.hidden">
          <a-icon v-if="child.meta.icon" :type="child.meta.icon" />
          <span>{{ child.meta.title }}</span>
        </a-menu-item>
      </template>
      <template v-else>
        <!-- 不隐藏 -->
        <template v-if="!child.hidden">
          <!-- 显示成menu-item 子菜单全没-->
          <template v-if="child.hideChildrenInMenu">
            <a-menu-item :key="child.path">
              <a-icon v-if="child.meta.icon" :type="child.meta.icon" />
              <span>{{ child.meta.title }}</span>
            </a-menu-item>
          </template>
          <template v-else>
            <sub-menu :key="child.path" :route="child"></sub-menu>
          </template>
        </template>
        <!-- 隐藏 子菜单全没 -->
        <template v-else> </template>
      </template>
    </template>
  </a-sub-menu>
</template>
<script>
export default {
  name: "SubMenu",
  props: {
    route: {
      type: Object,
      required: true
    }
  }
};
</script>
